const INTERNAL_REVIEW_STAGE = 'internal_review';
const PRESENTATION_STAGE = 'presented';

// "In Process w/ Client" spans both the `active` and `pre_hired` statuses,
// so it is defined by stage rather than status.
const WITH_CLIENT_STAGES = [
	PRESENTATION_STAGE,
	'client_assessment',
	'client_definition',
	'pre_hiring',
	'offer',
	'onboarding'
];

const IN_PROCESS_STAGES = [INTERNAL_REVIEW_STAGE, ...WITH_CLIENT_STAGES];

const REJECTED_BY_TALENT_STAGES = [
	'rejected_by_recruiter',
	'rejected_by_manager'
];

export const PIPELINE_KPI_FILTERS = {
	in_process: { stage: IN_PROCESS_STAGES },
	internal_review: { stage: [INTERNAL_REVIEW_STAGE] },
	with_client: { stage: WITH_CLIENT_STAGES },
	rejected: { status: 'rejected' },
	rejected_by_talent: { stage: REJECTED_BY_TALENT_STAGES },
	rejected_by_client: { stage: ['rejected_by_client'] },
	withdrawn: { status: 'withdrawn' },
	unresponsive: { stage: ['unresponsive'] },
	not_interested: { stage: ['not_interested'] },
	on_hold: { status: 'on_hold' },
	hired: { status: 'hired' }
};

export const EMPTY_PIPELINE_JOB_STATS = {
	inProcess: { total: 0, internalReview: 0, withClient: 0 },
	rejected: { total: 0, byTalent: 0, byClient: 0 },
	withdrawn: { total: 0, unresponsive: 0, notInterested: 0 },
	onHold: 0,
	hired: 0,
	avgPresentationDays: 0
};

const pluralize = (value, singular, plural = `${singular}s`) =>
	value === 1 ? singular : plural;

export const formatAvgPresentationTime = totalDays => {
	const days = Math.round(totalDays) || 0;

	if (days <= 0) {
		return {
			parts: [{ value: 0, unit: 'Days' }],
			label: '0 Days'
		};
	}

	if (days < 30) {
		const unit = pluralize(days, 'Day');
		return {
			parts: [{ value: days, unit }],
			label: `${days} ${unit}`
		};
	}

	const years = Math.floor(days / 365);
	const remainderAfterYears = days % 365;
	const months = Math.floor(remainderAfterYears / 30);
	const remainingDays = remainderAfterYears % 30;
	const parts = [];

	if (years > 0) {
		parts.push({
			value: years,
			unit: pluralize(years, 'Year')
		});
	}

	if (months > 0) {
		parts.push({
			value: months,
			unit: pluralize(months, 'Month')
		});
	}

	if (remainingDays > 0) {
		parts.push({
			value: remainingDays,
			unit: pluralize(remainingDays, 'Day')
		});
	}

	return {
		parts,
		label: parts.map(part => `${part.value} ${part.unit}`).join(' ')
	};
};

export const getInProcessDonutStyle = (internalReview, withClient) => {
	const total = internalReview + withClient;
	if (!total) {
		return { background: '#D9D6FE' };
	}

	const withClientDegrees = (withClient / total) * 360;
	return {
		background: `conic-gradient(#6938EF 0deg ${withClientDegrees}deg, #D9D6FE ${withClientDegrees}deg 360deg)`
	};
};
